import { Routes } from '@angular/router';
import { MainLayout } from './Common/Components/main-layout/main-layout';
import { authGuard } from './Common/Guards/auth.guard';
import { publicGuard } from './Common/Guards/public.guard';
import {StepGuide} from './Modules/Renewal_Manager/Components/step-guide/step-guide';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./Common/Components/login/login').then((m) => m.Login),
    canActivate: [publicGuard],
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./Common/Components/forgot-password/forgot-password').then((m) => m.ForgotPassword),
    canActivate: [publicGuard],
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./Common/Components/reset-password/reset-password').then((m) => m.ResetPassword),
    canActivate: [publicGuard],
  },
  {
    path: 'step-guide',
    loadComponent: () =>
      import('./Modules/Renewal_Manager/Components/step-guide/step-guide').then((m) => m.StepGuide),
    canActivate: [authGuard],
  },
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./Modules/Renewal_Manager/Pages/dashboard/dashboard').then((m) => m.Dashboard),
        data: { headerTitle: 'Renewal Insights', headerSubTitle: '' },
      },
      {
        path: 'contract-details/:id',
        loadComponent: () =>
          import('./Modules/Renewal_Manager/Pages/contract-details/contract-details').then(
            (m) => m.ContractDetails
          ),
        data: { headerTitle: 'Contract Details' },
      },
      {
        path: 'import',
        loadComponent: () =>
          import('./Modules/Renewal_Manager/Pages/import/import').then((m) => m.Import),
      },
      {
        path: 'service-history/:id',
        loadComponent: () =>
          import('./Modules/Renewal_Manager/Pages/service-history/service-history').then(
            (m) => m.ServiceHistory
          ),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];
